var _a;
import * as SportType from './SportType';
var cssClassMap = (_a = {},
    _a[SportType.TABLE_TENNIS] = 'ttennis',
    _a[SportType.BEACH_VOLLEYBALL] = 'beachvolley',
    _a[SportType.VOLLEYBALL] = 'volley',
    _a[SportType.BOX] = 'box',
    _a[SportType.TENNIS] = 'tennis',
    _a[SportType.FOOTBALL] = 'soccer',
    _a[SportType.ICE_HOCKEY] = 'icehockey',
    _a[SportType.HANDBALL] = 'handball',
    _a[SportType.BASEBALL] = 'baseball',
    _a[SportType.CYBER_SPORTS] = 'cybersports',
    _a[SportType.LOTTERY] = 'lottery',
    _a[SportType.AMERICAN_FOOTBAL] = 'americanfootball',
    _a[SportType.BANDY] = 'bandy',
    _a[SportType.BASKETBALL] = 'basketball',
    _a[SportType.BADMINTON] = 'badminton',
    _a[SportType.FUTSAL] = 'futsal',
    _a[SportType.FLOORBALL] = 'floorball',
    _a[SportType.WEATHER] = 'weather',
    _a[SportType.WATER_POLLO] = 'waterpolo',
    _a[SportType.BIATHLON] = 'biathlon',
    _a[SportType.BEACH_FOOTBALL] = 'beachsoccer',
    _a[SportType.MARTIAL_ARTS] = 'wrestling',
    _a[SportType.FORMULA1] = 'formula1',
    _a[SportType.CYCLING] = 'cycling',
    _a[SportType.ELECTIONS] = 'election',
    _a[SportType.DARTS] = 'darts',
    _a[SportType.KVN] = 'kvn',
    _a[SportType.CULTURE] = 'culture',
    _a[SportType.ATHLETICS] = 'athletics',
    _a[SportType.SKIING] = 'skiing',
    _a[SportType.OLYMPIC] = 'olimpicgames',
    _a[SportType.SWIMMING] = 'swimming',
    _a[SportType.POKER] = 'pocker',
    _a[SportType.RUGBY] = 'rugby',
    _a[SportType.HOCKEY] = 'hockeygras',
    _a[SportType.WHAT_WHERE_WHEN] = 'whatwherewhen',
    _a[SportType.CHESS] = 'chess',
    _a[SportType.SNOOKER] = 'pool',
    _a[SportType.BASKTBALL_NCAA] = 'basketball',
    _a);
export { cssClassMap };



// WEBPACK FOOTER //
// ./src/constants/SportCssMap.js